module.exports = __webpack_public_path__ + "img/Träumer.22ce2b3a.jpg";